export const CALL_CENTER_PHONE_NUMBER_BY_REGION: Record<string, string> = {
  au: '(02) 5300 3003',
  international: '+1 (213) 223-6100',
  nz: '0800 447 111',
  ca: '(647) 424 4288'
};

export const CALL_CENTER_MAIL_BY_REGION: Record<string, string> = {
  au: 'hello@dresden.vision',
  international: 'hello@int.dresden.vision',
  nz: 'hello@dresden.vision',
  ca: 'hello@ca.dresden.vision'
};

export const CALL_CENTER_WHATSAPP_BY_REGION: Record<string, string> = {
  au: 'https://wa.me/+61253003003'
};

export const CALL_CENTER_COUNTRY_BY_REGION: Record<string, string> = {
  au: 'Australia',
  ca: 'Canada',
  international: 'Australia',
  nz: 'New Zealand'
};